import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosNoAuth } from "./axiosInstance"

export const checkTrialPeriod = createAsyncThunk(
    'checkTrialPeriod',
    async ({ email, subject }) => {
        try {
            const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/global/user_account_status/banner', {
                params: {
                    email, subject
                }
            })
            return response.data
        } catch (error) {
            console.log(error.message)
            throw error;
        }
    }
)

// export const checkCertificateStatus = createAsyncThunk(
//     'checkCertificateStatus',
//     async ({  email, subject }) => {
//         try {
//             const response = await axiosNoAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/global/user_account_status/certificate', {
//                 params: {
//                     email, subject
//                 }
//             })
//             return response.data
//         } catch (error) {
//             console.log(error.message)
//         }
//     }
// )

const initialState = {
    name: "",
    isScholarshipApplied: false,
    lastPlayedLesson: 0,
    analysisPageButton: false,
    lastVisited: '',
    trialPeriod: {
        show_banner: false
    }
}

const nameSlice = createSlice({
    name: "name",
    initialState,
    reducers: {
        setUserName: (state, action) => {
            const { name } = action.payload;
            state.name = name;
        },
        setScholarshipDetails: (state, action) => {
            const { scholarship } = action.payload;
            state.isScholarshipApplied = scholarship; // Update the 'isScholarshipApplied' field in the state
        },
        setLastWatchedLesson: (state, action) => {
            const { lessonId } = action.payload
            state.lastPlayedLesson = lessonId
        },
        setAnalysisPageButtonClicked: (state, action) => {
            state.analysisPageButton = action.payload
        },
        setLastVisitedUrl: (state, action) => {
            state.lastVisited = action.payload
        },
        setTrialPeriod: (state, action) => {
            state.trialPeriod.show_banner = false
        }
    },
    extraReducers: (builder) => {
        builder.addCase(checkTrialPeriod.fulfilled, (state, action) => {
            state.trialPeriod = action.payload
        })
        // builder.addCase(checkCertificateStatus.fulfilled, (state, action) => {
        //     state.checkCertificateStatus = action.payload
        // })
    }
})

export const { setUserName, setScholarshipDetails, setLastWatchedLesson, setAnalysisPageButtonClicked, setLastVisitedUrl, setTrialPeriod } = nameSlice.actions
export const selectUserName = (state) => state.personaliseLessons?.name?.name
export const selectScholarship = (state) => state.personaliseLessons?.name?.isScholarshipApplied
export const selectLastPlayedLesson = (state) => state.personaliseLessons?.name?.lastPlayedLesson
export const selectAnalysisPageButtonClicked = (state) => state.personaliseLessons?.name?.analysisPageButton
export const selectLastVisited = (state) => state.personaliseLessons?.name?.lastVisited
export const selectTrialPeriod = (state) => state.personaliseLessons?.name?.trialPeriod
// export const selectCertificateStatus = (state) => state.personaliseLessons?.name?.checkCertificateStatus
export default nameSlice.reducer
